<template lang="pug">
.load-more
	button(@click="showMoreListings()", tabindex="0") Load More Job Listings
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	name: 'LoadMore',
	data() {
		return {}
	},
	computed: {
		...mapGetters(["activeListingCount"]),
	},
	methods: {
		...mapActions(["increaseActiveListingCount"]),
		showMoreListings() {
			this.increaseActiveListingCount(parseInt(this.$root.listingCount));
		}
	},
	mounted() {
		
	}
}
</script>

<style scoped lang="scss">
.load-more {
	button {
		background: transparent;
		border: none;
		color: $darkGray;
		font-weight: 700;
		cursor: pointer;
		margin: 2rem auto 0;
		display: block;
		padding: 0.25rem;
		@include fluid(font-size, 1rem, 1.125rem);
		@include linkHover;
		@include mqdn(md) {
			&:hover {
				color: $darkGray;
				background-size: 100% 1px;
			}
			&:active {
				color: $white;
				background-size: 100% 100%;
			}
		}
	}
}
</style>
